export default {
  FEEDBACK_ADD: 'FEEDBACK_ADD',
  FEEDBACK_ADD_SUCCESS: 'FEEDBACK_ADD_SUCCESS',
  FEEDBACK_ADD_ERROR: 'FEEDBACK_ADD_ERROR',
  FEEDBACK_ADD_WARNING: 'FEEDBACK_ADD_WARNING',
  FEEDBACK_SEEN: 'FEEDBACK_SEEN',
};
